import { useCallback } from "react";
import {
  getTempoClipboardDataFromDrop,
  useInsertClipboardDataIntoCanvas,
} from "../utils/canvasClipboardData";
import { useHandleImagePaste } from "./useCopyPaste";
import { toast } from "sonner";

export const useOnDrop = () => {
  const { insertClipboardDataIntoCanvas } = useInsertClipboardDataIntoCanvas();

  const handleImagePaste = useHandleImagePaste();

  const handleDropEvent = useCallback(
    async (e: React.DragEvent<Element>) => {
      const files = e.dataTransfer.files;
      let imageBlob: File | null = null;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file.type.startsWith("image/")) {
          imageBlob = file; // File object is a Blob
          break;
        }
      }

      if (imageBlob) {
        e.preventDefault();
        e.stopPropagation();

        try {
          await handleImagePaste(imageBlob);
        } catch (error) {
          console.error("Couldn't handle inserting image:" + error);
          toast.error("Failed to insert image");
        }
        return;
      }

      const tempoCopyData = getTempoClipboardDataFromDrop(e);
      if (tempoCopyData) {
        insertClipboardDataIntoCanvas(tempoCopyData);
      }
    },
    [insertClipboardDataIntoCanvas, handleImagePaste],
  );

  return { handleDropEvent, insertClipboardDataIntoCanvas };
};
